var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-secondary",staticStyle:{"height":"100%"}},[_c('nav-header',{attrs:{"title":"Areas"}}),_c('area-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }